import React from 'react';
import { Download } from '../../ui/icon/Download';

export default function Loading(data) {
  const { additionalData } = data;
  return (
    <>
      {Array.from({ length: 12 }, (_, index) => (
        <div key={index} className={additionalData && additionalData.type && additionalData.type === 'private' ? 'col-md-6 col-lg-4' : 'col-md-6 col-lg-4 col-xl-3'}>
          <div className="card animate-pulse">
            <div className="card-body">
              <div className="card-head" />
              <div className="h3" />
              <div className="mb-2 mb-md-3">
                <span className="figure-caption" />
              </div>
              <div className="press-release-pack__button">
                <Download />
                <span />
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
